import { EditableText } from '@frontend/editable-text';
import { useTranslation } from '@frontend/i18n';
import { FieldProps, TextField, Stepper, Text } from '@frontend/design-system';
import { overrideTextStyles, stepValueContainerStyles } from './styles';

type TemplateTileStepProps = {
  fieldProps: FieldProps<
    {
      name: {
        type: 'text';
        required: boolean;
        placeholder: string;
        value: string;
        validateOnChange: boolean;
      };
    },
    'name'
  >;
  next: () => void;
  isFormModeEdit: boolean;
};

export const TemplateTileStep = ({ fieldProps, next, isFormModeEdit }: TemplateTileStepProps) => {
  const { t } = useTranslation('templates-settings');
  return (
    <>
      {!isFormModeEdit && <Stepper.Title>{t('Name Your Template')}</Stepper.Title>}
      <Stepper.Content>
        <EditableText fieldProps={fieldProps} helperText={t('Required')} />
      </Stepper.Content>

      {!isFormModeEdit && (
        <Stepper.ButtonBarAlternate>
          <Stepper.ButtonAlternate
            onClick={() => {
              if (!!fieldProps.value) next();
            }}
            disabled={!fieldProps.value}
            position='primary'
            type='none'
          >
            {t('Next')}
          </Stepper.ButtonAlternate>
        </Stepper.ButtonBarAlternate>
      )}
    </>
  );
};

export const TemplateTitleNonStepper = ({ fieldProps }: TemplateTileStepProps) => {
  const { t } = useTranslation('templates-settings');
  return <TextField {...fieldProps} label={t('Template Title')} />;
};

export const TemplateTileStepCollapsed = ({ fieldProps }: Pick<TemplateTileStepProps, 'fieldProps'>) => {
  return (
    <div css={{ ...stepValueContainerStyles, flexDirection: 'column' }}>
      {fieldProps.value && <Text css={overrideTextStyles}>{fieldProps.value}</Text>}
    </div>
  );
};
